module.exports = __webpack_public_path__ + "img/hoehle3.720e8090.jpg";